(function ($) {

    $(function () {
        var wow = new WOW({
            boxClass: 'wow',
            offset: 100,
            mobile: true,
            live: true,
            callback: function (box) {
                $(box).addClass('animate-complete');
            },
        });
        wow.init();

        $(".mega-menu #mobile-forgot-password").on("click", function () {
          $(".mega-menu #mobile-login-wrapper").hide();
          $(".mega-menu #mobile-forgot-wrapper").show();
        });

        $(".mega-menu #mobile-back-login").on("click", function () {
          $(".mega-menu #mobile-login-wrapper").show();
          $(".mega-menu #mobile-forgot-wrapper").hide();
        });
    });
    // $(document).ready(function () {
    //     $(".link-more span").each(function (e) {
    //         $(this).click(function () {
    //             $(this).parent().toggleClass("expanded");
    //
    //         });
    //     })
    //
    // });



// Force external links to open in new tab / window
    $(function () {
        var siteName = window.location.host.replace('www.', '');
        $('a[href^="htt"]:not([target]):not([href*="www.' + siteName + '"]):not([href*="//' + siteName + '"]):not([class*="fancybox"])').attr('target', '_blank');
    });


    if (window.location.href.indexOf("?hooverpress") > 0) {
        $('.regular-topic').remove();
        $('.hooverpress').show();
    } else {
        $('.hooverpress').remove();
    }
    if ($('.shorthand_story').length > 0) {
        $('.shorthand_story').html($('.shorthand_story').html().replace("✖", ""));
    }
    $(document).ready(function () {
      if ($(".report-2024").length > 0) {
        return;
      }
  
      $("body").prepend('<div class="left-side-color"></div>');
      $("body").append('<div class="right-side-color"></div>');
  
      $(window).on("resize", function () {
          setTimeout(function () {
            added_body_color();
          }, 300);
      });
  
      $(window).on("load", function () {
          setTimeout(function () {
            added_body_color();
          }, 300);
      });
    });
           // added body color
           function added_body_color() {
            if ($(".report-2024").length > 0) {
              return;
            }
            if($(window).width() > 1920) {
              var $extraSpace = $(window).width()-1920;
              var $half_space = $extraSpace/2;
              var $body_height = $("body").outerHeight();
              $(".left-side-color").css("width", $half_space + "px");
              $(".right-side-color").css("width", $half_space + "px");
              $(".left-side-color").css("height", $body_height + "px");
              $(".right-side-color").css("height", $body_height + "px");
              $(".left-side-color").css("display", "block");
              $(".right-side-color").css("display", "block");
            }
            if($(window).width() < 1920) {
              $(".left-side-color").css("display", "none");
              $(".right-side-color").css("display", "none");
            }
          }

    $( ".menu-item" ).hover(
        function() {
            $('.toolbar-icon').each(function () {
                var text = $(this).text().replace('&amp;','&');
                $(this).html(text);
            });
        }
    );


    // $("h1, h2, h3, h4, h5, h6, p, span").each(function () {
    //     var text = $(this).text();
    //     $(this).text(replace(text));
    // });
    // function replace (text) {
    //     text = text.replace(/&amp;/g, '&').replace(/&nbsp;/g, ' ');
    //     // console.log(text);
    //     return text;
    // }

    // Add the title for missing iframe
    document.addEventListener('DOMContentLoaded', () => {
      const iframes = document.querySelectorAll('body iframe');
      iframes.forEach((iframe, index) => {
        // Check if the iframe already has a title
        if (!iframe.hasAttribute('title')) {
          iframe.setAttribute('title', `Hoover Iframe ${index + 1}`);
        }
      });
    });
    
// Send data in data layer on Myhoover click
document.addEventListener('DOMContentLoaded', function () {
  const myHooverLinks = document.querySelectorAll('.myhoover-myfeed-btn');

  // Iterate through each link and add the click event listener
  myHooverLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
          
          if (window.dataLayer) {
              dataLayer.push({
                  event: "myhoover_login_2024",
                  eventCategory: "MyHoover Nav",
                  eventAction: "Click",
                  eventLabel: "MyHoover MyFeed Button"
              });
          }
      });
  });
});

// Send data to dataLayer if the 'active-user' class is added dynamically
document.addEventListener('DOMContentLoaded', function () {
  const myHooverLoggedinLinks = document.querySelectorAll('a.myhoover-myfeed-btn');

  // Observe changes to dynamically detect 'active-user' class
  const observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              const target = mutation.target;
              if (
                  target.tagName === 'A' &&
                  target.classList.contains('myhoover-myfeed-btn') &&
                  target.classList.contains('active-user')
              ) {
                  if (window.dataLayer && Array.isArray(window.dataLayer)) {
                      dataLayer.push({
                          event: "activeUserDetected_2024",
                          eventCategory: "MyHoover Nav",
                          eventAction: "Active User",
                          eventLabel: "MyHoover Active User Link"
                      });
                      console.log('Data sent to dataLayer for dynamically added active-user:', target.href);
                  }
              }
          }
      });
  });

  // Observe each link for attribute changes
  myHooverLoggedinLinks.forEach(function (link) {
      observer.observe(link, { attributes: true, attributeFilter: ['class'] });
  });
});


// link missing a title attribute
  document.addEventListener('DOMContentLoaded', function () {
    // Select all anchor tags in the body
    const anchors = document.querySelectorAll('body a');

    anchors.forEach(anchor => {
        // Check if the anchor has text content
        const hasText = anchor.textContent.trim() !== '';
        const hasAriaLabel = anchor.hasAttribute('aria-label');

        if (!hasAriaLabel) {
            if (hasText) {
                // Use the anchor's text content for aria-label
                anchor.setAttribute('aria-label', anchor.textContent.trim());
            } else {
                // Use the default value for aria-label
                anchor.setAttribute('aria-label', 'Web Accessibility Initiative');
            }
        }
    });
});

// Image missing a text alternative
document.addEventListener('DOMContentLoaded', () => {
  const images = document.querySelectorAll('img');

  images.forEach((img) => {
      if (!img.hasAttribute('alt') || img.alt.trim() === '') {
          const defaultAlt = 'Image description not available'; // Default text for missing alt
          img.setAttribute('alt', defaultAlt);
      }
  });
});
// Google captcha inline iframe missing a title 
document.addEventListener('DOMContentLoaded', () => {
  const addTitleToRecaptcha = () => {
      const captchaIframes = document.querySelectorAll('iframe[src*="recaptcha"]');
      captchaIframes.forEach((iframe) => {
          if (!iframe.hasAttribute('title')) {
              iframe.setAttribute('title', 'Google reCAPTCHA verification frame');
          }
      });
  };
  // Initial check for existing iframes
  addTitleToRecaptcha();
  // Observe for dynamically added iframes
  const observer = new MutationObserver(() => {
      addTitleToRecaptcha();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

// Form field missing a label
document.addEventListener('DOMContentLoaded', function () {
    const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
            if (mutation.type === 'childList') {
                const selectElement = document.querySelector('.ais-SortBy-select');
                if (selectElement && !selectElement.hasAttribute('aria-label') && !document.querySelector(`label[for="${selectElement.id}"]`)) {
                    selectElement.setAttribute('aria-label', 'Sort by');
                }
            }
        });
    });

    // Start observing the DOM for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
});


// Remove empty tables immediately
$("table:empty").remove();


})(jQuery);
